module.exports = __webpack_public_path__ + "img/petstairs26.b28fee6b.jpg";